export const getDate = (date: Date, daysAgo: number = 0) => {
    if (daysAgo === 0) {
        return date.toISOString().split('T')[0]
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() - daysAgo)
        .toISOString()
        .split('T')[0]
};